import styled from '@emotion/styled';
import { UniverseModuleType } from 'src/domains/common/universes.type';

export const setMainLogoWrapper = (theme: UniverseModuleType['themeColors'] | undefined): string => {
    const bgColor = theme === undefined ? '#111' : theme.header.bgColorSecondary;
    return `
        align-items: center;
        display: flex;
        flex: 0 0 248px;
        height: 56px;
        padding: 16px;
        position: relative;
        background: ${bgColor};
    `;
};

export const DefaultMainLogoWrapper = styled('div', { label: 'DefaultMainLogoWrapper' })`
    ${setMainLogoWrapper(undefined)}
`;

export const DeafaultLogoTitle = styled('h1', { label: 'DeafaultLogoTitle' })`
    color: #fff;
    font-size: 22px;
    text-transform: capitalize;
`;
